import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Statistic, Spin } from 'antd';
import {
  UserOutlined,
  MedicineBoxOutlined,
  FormOutlined,
  ShoppingOutlined,
  ProfileOutlined,
  ShopOutlined,
  MessageOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import request from '../utils/request';

const Dashboard: React.FC = () => {
  const [summary, setSummary] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    request
      .get('/dashboard/summary')
      .then((res: any) => setSummary(res))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Spin spinning={loading}>
      <div>
        <h2>仪表盘</h2>
        <Row gutter={16} style={{ marginTop: 24 }}>
          <Col span={6}>
            <Card>
              <Statistic title="用户总数" value={summary?.userCount ?? 0} prefix={<UserOutlined />} />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic title="科室数量" value={summary?.departmentCount ?? 0} prefix={<MedicineBoxOutlined />} />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic title="医生数量" value={summary?.doctorCount ?? 0} prefix={<TeamOutlined />} />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic title="商品数量" value={summary?.productCount ?? 0} prefix={<ShoppingOutlined />} />
            </Card>
          </Col>
        </Row>
        <Row gutter={16} style={{ marginTop: 16 }}>
          <Col span={6}>
            <Card>
              <Statistic title="今日挂号" value={summary?.todayRegistration ?? 0} prefix={<FormOutlined />} />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic title="挂号总数" value={summary?.registrationCount ?? 0} prefix={<FormOutlined />} />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic title="今日订单" value={summary?.todayOrder ?? 0} prefix={<ProfileOutlined />} />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic title="订单总数" value={summary?.orderCount ?? 0} prefix={<ProfileOutlined />} />
            </Card>
          </Col>
        </Row>
        <Row gutter={16} style={{ marginTop: 16 }}>
          <Col span={6}>
            <Card>
              <Statistic title="待支付订单" value={summary?.pendingPayOrder ?? 0} prefix={<ProfileOutlined />} valueStyle={{ color: '#faad14' }} />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic title="已支付待完成订单" value={summary?.paidOrder ?? 0} prefix={<ProfileOutlined />} valueStyle={{ color: '#065F46' }} />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic title="待处理反馈" value={summary?.pendingFeedback ?? 0} prefix={<MessageOutlined />} valueStyle={{ color: summary?.pendingFeedback ? '#f5222d' : undefined }} />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic title="门店数量" value={summary?.storeCount ?? 0} prefix={<ShopOutlined />} />
            </Card>
          </Col>
        </Row>
      </div>
    </Spin>
  );
};

export default Dashboard;
